import React, { Fragment } from 'react';
import { css } from 'styled-components';
import PropTypes from 'prop-types';
import Title from './Title';
import { StyledTeamImage } from './resultsStyles';
import Text from './Text';
import CTAButton from './CTAButton';

const Contact = ({ title, subTitle, imgUrl, onClick, event }) => (
  <Fragment>
    <Title
      level={3}
      styles={css`
        align-self: center;
      `}
      medium
      align="center"
    >
      {title}
    </Title>
    <Text type="body2" align="center">
      {subTitle}
    </Text>
    <StyledTeamImage src={imgUrl} />

    <CTAButton
      nolink
      blank
      customOnClick={() => {
        onClick();
      }}
      buttonText="Abrir Chat"
      event={event}
    />
  </Fragment>
);

Contact.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  imgUrl: PropTypes.string,
  onClick: PropTypes.func,
  event: PropTypes.string,
};

Contact.defaultProps = {
  title: '',
  subTitle: '',
  imgUrl: '',
  onClick: () => {},
  event: '',
};

export default Contact;
